<!--
 * @Author: your name
 * @Date: 2020-12-23 14:49:48
 * @LastEditTime: 2021-03-23 16:59:25
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Description: 区号组件
 * @FilePath: /hsylc2021/src/components/form/AreaCodeSelect/areaCodeSelect.vue
-->
<template>
  <div class="component-areaCode-select">
    <Select
      :label="label"
      :options="areaCodeOption"
      :value="value"
      @change="handleChange"
      @blur="handleBlur"
      :startVerific="startVerific"
      :placeholder="placeholder"
      :isError="isError"
      :isVerific="isVerific"
      :errmsg="errmsg"
    />
  </div>
</template>
<script>
/**
 * 区号组件
 * @module AreaCodeSelect
 */
import Select from '@/components/form/Select/select';
import AREACODE from './areaCode';
export default {
  name: 'AreaCodeSelect',
  /**
   * @prop {String} value 组件数据
   * @prop {Boolean} isCountry 是否显示国籍 true 国籍 false 区号 默认false
   * @prop {label} label label
   */
  props: {
    label: {
      type: String,
      default: '国际区号'
    },
    isCountry: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isError: {
      type: Boolean,
      default: false
    },
    isVerific: {
      type: Boolean,
      default: true
    },
    errmsg: {
      type: String,
      default: ''
    }
  },
  /**
   * @prop {Component} Select 下拉框组件
   */
  components: {
    Select
  },
  /**
   * @prop {Array} areaCodeOption 下拉框数据
   */
  data() {
    return {
      areaCodeOption: [
        {
          value: '选项1',
          label: '黄金糕'
        }
      ]
    };
  },
  mounted() {
    this.InitAreaCode();
    // console.log('startVerific:', this.startVerific);
  },
  methods: {
    /**
     * @description 初始化 区号数据格式
     * @function InitAreaCode
     */
    InitAreaCode() {
      const that = this;
      let resultArr = [];
      AREACODE.forEach(item => {
        if (!that.isCountry && item.short === 'CA') return;
        let temp = {
          value: !that.isCountry ? '+' + item.tel : item.name,
          label: !that.isCountry ? '+' + item.tel : item.name
        };
        resultArr.push(temp);
      });

      this.areaCodeOption = resultArr;
    },

    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 组件数据变化事件
     * @function handleChange
     * @param {String} val 带符号的区号
     */
    handleChange(val) {
      this.$emit('input', val);
    },
    handleBlur(error, id, errmsg) {
      this.$emit('blur', error, this.id, errmsg);
    }
  }
};
</script>
<style lang="less" src="./areaCodeSelect.less" scoped></style>
